<div class="row">
  <div class="col-xs-12">
    <p><strong>Tipo:</strong> {{::ocorrencia.tipo.descricao}}</p>
    <p><strong>Data:</strong> {{::ocorrencia.data | date:'dd/MM/yyyy'}} {{::ocorrencia.hora | date:'HH:mm'}}</p>
    <p><strong>Máquina:</strong> {{::ocorrencia.maquina.descricao | capitalize}}</p>
    <p><strong>Operador:</strong> {{::ocorrencia.operador.nome | capitalize}}</p>
    <p><strong>Status:</strong> {{::ocorrencia.status.descricao | capitalize}}</p>
    <p><strong>Relato:</strong> {{::ocorrencia.relato}}</p>
  </div>
</div>